import React, { Component } from 'react';
import { Container, Grid } from 'semantic-ui-react';
import ExploreContent from './ExploreContent';

export class Explore extends Component {
  render() {
    return (
      <Container fluid>
        <Container className="explore-cards">
            <Grid stackable celled='internally' columns='5'>
              <Grid.Row>
                <Grid.Column>
                  <ExploreContent name='composers' title='Composers'>
                    <p>
                      We are proud to feature an ever-growing list of composers
                      who may self-curate the information that appears in Living
                      Song Project. Search here for living composers who are
                      writing American art songs and vocal chamber music.
                      Discover the diversity and richness that exists within. 
                    </p>
                  </ExploreContent>
                </Grid.Column>
                <Grid.Column>
                  <ExploreContent name='text-authors' title='Text Authors'>
                    <p>
                      Composers collaborate with poets and interact with the
                      written word. Search here to find authors associated with
                      our composers, who set both poetry and prose texts in a
                      variety of languages. Dive into relationships that are
                      both contemporaneous and stretching across the centuries.
                    </p>
                  </ExploreContent>
                </Grid.Column>
                <Grid.Column>
                  <ExploreContent name='song-cycles' title='Song Cycles &amp; Collections'>
                    <p>
                      If what you are looking for is a song cycle, you
                      can find it here. You can also find collections
                      of songs, as organized by our composers. Once
                      you’ve taken the plunge, you’ll be able to
                      narrow your search by a myriad of things like
                      range, duration, poet, composer, and
                      geographical details, to name just a few.
                    </p>
                  </ExploreContent>
                </Grid.Column>
                <Grid.Column>
                  <ExploreContent name='songs' title='Songs'>
                    <p>
                      Start here to explore the vast amount of art song
                      repertoire contained in the database. Some are contained
                      in song cycles, some are parts of organized collections,
                      and some are individual songs, all as laid out by our
                      composers.
                    </p>
                  </ExploreContent>
                </Grid.Column>
                <Grid.Column>
                  <ExploreContent name='chamber-music' title='Vocal Chamber Music'>
                    <p>
                    Search for songs and cycles for voice or voices with an
                    instrument (other than piano), or a number of instruments,
                    here. We have included only works that do not require a
                    conductor. This exciting body of repertoire is yours to
                    investigate as you ponder the possibilities. 
                    </p>
                  </ExploreContent>
                </Grid.Column>
              </Grid.Row>
            </Grid>
        </Container>
      </Container>
    );
  }
}